import { apiClient } from "@/service/ApiClient";

/** 참가자 조회용 */
export interface PlayerData {
    id: number
    gameId: number
    teamId: number
    memberId?: number
    name: string
    position1: string
    position2?: string
    teamABType: 'A' | 'B'
    goal?: number
    assist?: number
    status: string
}

/** 등록 / 수정용 */
export interface PlayerItem {
    id?: number
    gameId: number
    memberId?: number      // 용병이면 없음
    name: string
    position1: string
    position2?: string
    teamABType: 'A' | 'B'
}

/** 게임별 참가자 목록 */
const getPlayersByGame = async (gameId: number) =>
    apiClient
        .get<PlayerData[]>(`/players/game/${gameId}`)
        .then(res => res.data)

/** 참가자 추가 (회원 / 용병 공통) */
const postPlayer = async (player: PlayerItem) =>
    apiClient
        .post<PlayerData>('/players', { ...player })
        .then(res => res.data)

/** 참가자 수정 */
const putPlayerResult = async (player: PlayerItem) =>
    apiClient
        .patch<PlayerData>(`/players/${player.id}`, { ...player })
        .then(res => res.data)

/** 참가자 삭제 */
const deletePlayer = (playerId: number) =>
    apiClient.delete(`/players/${playerId}`)

const PlayerService = {
    getPlayersByGame,
    postPlayer,
    putPlayerResult,
    deletePlayer
}

export default PlayerService
